import React, { useEffect, useMemo } from 'react'
import { components, useTranslation } from 'cng-web-lib'
import { Dialog, DialogContent, DialogTitle, DialogActions, Typography, Divider } from '@material-ui/core'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import GoodsInfoFormProperties from './GoodsInfoFormProperties'
import GoodsInfoMakeValidationSchema from './GoodsInfoMakeValidationSchema'

const {
  button: { CngButton }
} = components

function GoodsInfoDialog(props) {
  const { goodsInfo, isView, onAddGoodsInfo, onEditGoodsInfo, open, onClose, showNotification, documentType } = props
  const { translate } = useTranslation(Namespace.UAE_MPCI)
  const title = translate(Namespace.UAE_MPCI, UaeMpciKeys.GoodsInfo.TITLE)
  const saveButton = translate(Namespace.UAE_MPCI, UaeMpciKeys.SAVE_BUTTON)

  const validationSchema = useMemo(
    () => GoodsInfoMakeValidationSchema(translate, documentType),
    [translate, documentType]
  )

  const methods = useForm({
    defaultValues: GoodsInfoFormProperties.formikProps.initialValues,
    resolver: yupResolver(validationSchema)
  })

  const { handleSubmit, reset } = methods

  useEffect(() => {
    if (open) {
      if (goodsInfo) {
        reset(goodsInfo)
      } else {
        reset(GoodsInfoFormProperties.formikProps.initialValues)
      }
    }
  }, [open, goodsInfo])

  function onSubmit(data) {
    if (goodsInfo) {
      onEditGoodsInfo(data)
    } else {
      onAddGoodsInfo(data)
    }
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <DialogTitle>
        <Typography variant="h5"><strong>{title}</strong></Typography>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <FormProvider {...methods}>
          <form>
            <GoodsInfoFormProperties.Fields disabled={isView} documentType={documentType} />
          </form>
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <CngButton color="secondary" onClick={onClose} size="medium">Cancel</CngButton>
        {!isView && (
          <CngButton color="primary" onClick={handleSubmit(onSubmit)} size="medium">
            {goodsInfo ? 'Update' : saveButton}
          </CngButton>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default GoodsInfoDialog
